@if(form){
  <div class='ticket-card'>
    <div class="header" [formGroup]="form">
      <span class="label">
        {{ "APP.BOOK_EVENT_SLOT.TICKET" | translate }} {{ index }}
      </span>

      @if (index == 1 && !attendee && showAssignToBuyer) {
        <mat-checkbox formControlName="assignToBuyer" (change)="populateFields($event.checked)">
          {{ "APP.BOOK_EVENT_SLOT.ASSIGN_TO_BUYER" | translate }}
        </mat-checkbox>
      }
    </div>

    <div class='body'>
     @if(slot?.accountRequirement !== AccountRequirement.REQUIRED && !attendee){
       <div class="slide-toggle-cont" [formGroup]="form">
         <div> {{ "APP.BOOK_EVENT_SLOT.FILL_IN_LATER" | translate }} </div>
         <label class="toggle-check">
           <input
             type="checkbox"
             class="toggle-check-input"
             formControlName="fillInDataLater"
           />
           <span class="toggle-check-text"></span>
         </label>
       </div>
     }

      @if(!form.controls['fillInDataLater'].value){
        <form [formGroup]="form" class='form'>
          <div class='form-group'>
            <mat-form-field
              class="flex-half-shrink flex-input"
              appearance="outline"
            >
              <mat-label class="placeholder"> {{ "APP.BOOK_EVENT_SLOT.NAME" | translate }} {{ getAsteriskIfRequired('firstName') }} </mat-label>
              <input type="text" matInput formControlName="firstName" placeholder="" />
            </mat-form-field>

            <mat-form-field
              class="flex-half-shrink flex-input"
              appearance="outline"
            >
              <mat-label class="placeholder"> {{ "APP.BOOK_EVENT_SLOT.LAST_NAME" | translate }} {{ getAsteriskIfRequired('lastName') }}  </mat-label>
              <input type="text" matInput formControlName="lastName" placeholder="" />
            </mat-form-field>

            <mat-form-field
              class="flex-half-shrink flex-input with-hint"
              appearance="outline"
            >
              <mat-label class="placeholder"> {{ "APP.BOOK_EVENT_SLOT.EMAIL" | translate }} {{ getAsteriskIfRequired('email') }} </mat-label>
              <input type="email" matInput formControlName="email" placeholder="" />
              <mat-hint> {{ "APP.BOOK_EVENT_SLOT.TICKET_WILL_BE_SENT_TO_EMAIL" | translate }} </mat-hint>
            </mat-form-field>
          </div>
          <div class='form-group'>
            @if (dataFields && dataFields.length) {
                @for (dataField of dataFields; track dataField.id) {
                  <app-event-rsvp-question
                    [form]="form"
                    [question]="dataField"
                    [slot]='slot'
                    [attendee]='attendee'
                    matFormFieldClass="w-100"
                    class="payment-data-field"
                  ></app-event-rsvp-question>
                }
            }
          </div>

        </form>
      }

    </div>
  </div>
}
